import React from 'react'
import Helmet from 'react-helmet'
import StructuredDataType from '../../utils/structured-data'

interface IStructuredDataProps {
  data: StructuredDataType
}

export function StructuredData({ data }: IStructuredDataProps) {
  if (!data || data.length === 0) {
    return null
  }
  
  return (
    <Helmet defer={false}>
      {data &&
        data?.map((d) => (
          <script key={d['@type']} type="application/ld+json">
            {JSON.stringify(d)}
          </script>
        ))}
    </Helmet>
  )
}
